<template>
  <div class="cart-totals">
    <h4>Order Summary</h4>
    <div class="summary">
      <div>Subtotal</div>
      <div class="right"><Currency :amount="cart.subtotal" /></div>
      <template v-if="cart.object.totals">
        <template v-for="extra of cart.object.totals.extras">
          <div>{{ extra[0] }}</div>
          <div class="right"><Currency :amount="extra[1]" /></div>
        </template>
      </template>

      <template v-else>
        <template v-if="cart.estimatedTaxes">
          <div>Estimated Tax</div>
          <div class="right"><Currency :amount="cart.estimatedTaxes" /></div>
        </template>
        <template v-if="shipping.shipper">
          <div
            class="ellipsis"
            :title="cart.object.shipping_description || 'Shipping'"
          >
            {{ cart.object.shipping_description || "Shipping" }}
          </div>
          <div class="right">
            <Currency :amount="shippingPrice" />
          </div>
        </template>
        <div>Est. Cost</div>
        <div class="right">
          <Currency :amount="cart.total" />
        </div>
        <template v-for="[label, amount] of checkout.balance.credits">
          <div>{{ label }}</div>
          <div class="right">-<Currency :amount="amount" /></div>
        </template>
      </template>

      <div>Total Items</div>
      <div class="right">{{ cart.count }}</div>

      <template v-if="user.isRep">
        <div>Total Volume</div>
        <div class="right">{{ cart.volume }}</div>
      </template>

      <div class="total-border"></div>
      <div class="total-border"></div>

      <div class="bolder">Total</div>
      <div class="right bolder">
        <div
          v-if="
            cart.object.totals
              ? cart.object.totals?.total === 0
              : checkout.balance.total === 0
          "
        >
          FREE!
        </div>
        <Currency
          v-else-if="cart.object.totals"
          :amount="cart.object.totals.total"
        />
        <Currency v-else :amount="checkout.balance.total" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Currency from "@/components/shop/Currency.vue";
import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkout";
import { useShippingStore } from "@/stores/shipping";
import { useUserStore } from "@/stores/user";
import { computed } from "vue";

const cart = useCartStore();
const user = useUserStore();
const checkout = useCheckoutStore();
const shipping = useShippingStore();

const shippingPrice = computed<number>(() => {
  return cart.object.shipping_price as number;
});
</script>

<style scoped>
.cart-totals {
  width: 260px;
  h4 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 300;
    margin: 0 0 var(--3XS, 8px) 0;
  }
}
.right {
  text-align: right;
}
.summary-column {
  width: 230px;
}
.summary-column h4 {
  color: var(--Black, #000);

  /* Heading 4 */
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  margin: 0 0 5px 0;
}
.summary {
  padding: var(--XS);
  border: 1px solid var(--30, #c4c4c4);
  display: grid;
  grid-template-columns: auto auto;
  font-size: 14px;
  line-height: 1.5;
}
.summary hr {
  grid-column: 1 / -1;
}

.summary .bolder {
  font-weight: 500;
  line-height: 1;
}
.summary > div {
  white-space: nowrap;
}

.total-border {
  border-top: 1px solid #c4c4c4;
  margin-top: 16px;
  padding-bottom: 16px;
}
.ellipsis {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
